import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import { store } from './store';
import App from './App';
import './i18n'; // initialises i18next as a side effect — must run before any `useTranslation()`
// Self-hosted fonts (no third-party requests on pages that handle secrets).
import '@fontsource-variable/archivo/wdth.css';
import '@fontsource/atkinson-hyperlegible-next/400.css';
import '@fontsource/atkinson-hyperlegible-next/700.css';
import '@fontsource/dm-mono/500.css';
import './styles/theme.css';
import './styles/base.css';
import { applyThemePreference, browserThemeStorage, readThemePreference } from './lib/theme';

// Apply a saved light/dark choice before the first render.
applyThemePreference(document.documentElement, readThemePreference(browserThemeStorage()));

// Use HashRouter inside Electron — the renderer loads via `file://` and
// path-based routing doesn't survive a hard refresh under that scheme.
// Browser builds keep the cleaner BrowserRouter.
const Router = window.electronAPI ? HashRouter : BrowserRouter;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </React.StrictMode>,
);
